module.exports = __webpack_public_path__ + "img/indoor_hum.a40ada9c.png";